function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.29 16.29h-4.75a2.715 2.715 0 11-5.43 0H1.36A1.37 1.37 0 010 14.93c1.57-1.33 3.39-3.7 3.39-8.82a5 5 0 014.5-4.68 1.06 1.06 0 01-.08-.41 1 1 0 112 0 1.06 1.06 0 01-.08.41 5 5 0 014.5 4.68c0 5.12 1.82 7.5 3.39 8.82a1.37 1.37 0 01-1.33 1.36zm-.57-1.36c-1.9-2.14-2.82-5-2.82-8.82a4.14 4.14 0 00-8.14 0c0 3.78-.92 6.68-2.82 8.82h13.79zm-6.89 2.88a1.53 1.53 0 01-1.53-1.53.17.17 0 10-.34 0 1.87 1.87 0 001.87 1.87.17.17 0 10-.01-.33z"
});

var SvgBellO = function SvgBellO(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 17.65 19"
  }, props), _ref);
};

export default SvgBellO;